import {getI18n, useTranslation} from "react-i18next";

export default function GoodsCard({ data }) {
  const { t } = useTranslation();
  const lang = getI18n().language;
  
  return (
    <>
      <div className="py-[12px] flex mdmax:hidden">
        <div className="w-[140px] h-[140px] bg-[#eee] mr-[3%] flex-none rounded-[5px] overflow-hidden">
          <img src={data.imgPathView}/>
        </div>
        <div className="flex flex-1 pt-[12px]">
          <div className="flex-1 pr-[10px]">
            <p className="font-bold text-[16px] mb-[15px]">{lang === 'en'?data.productEnName:data.productName}</p>
            <p className="mb-[15px] text-[#999]">{t('规格')}：{data.specName}</p>
            {/*<p className="mb-[15px] text-[#999]">這裡是描述哦，這裡是描述哦</p>*/}
          </div>
          <div className="text-center w-[15%]">
            <p>{t('单价')}：${data.salePrice}</p>
          </div>
          <div className="text-center w-[15%]">
            <p>{t('数量')}：{data.productQty}</p>
          </div>
          <div className="text-center w-[15%]">
            <p>${data.productTotalPrice}</p>
          </div>
        </div>
      </div>
      
      <div className="py-[10px] flex md:hidden flex items-center">
        <div className="w-[85px] h-[85px] bg-[#eee] flex-none mr-[15px] items-center rounded-[5px] overflow-hidden">
          <img src={data.imgPathView}/>
        </div>
        <div>
          <p className="text-[13px]" style={{ lineHeight: '18px' }}>{lang === 'en'?data.productEnName:data.productName}</p>
          <p className="text-[#999] text-[12px]">{t('规格')}：{data.specName}</p>
          <p className="text-[#999] text-[12px]">x{data.productQty}</p>
          <p className="text-[12px]">${data.salePrice}</p>
        </div>
      </div>
    </>
  );
}
